module.exports = __webpack_public_path__ + "static/nettiterapia.4b628591.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nettiterapia.jpg
// module id = 833
// module chunks = 41163700655044